import { useRole } from '@/hooks/useRole'
import { Box } from '@mui/material'
import { type FC } from 'react'
import { MenuLink } from './components/MenuLink'
import { styles } from './styles'
import type { SidebarMenuProps } from './types'

export const SidebarMenu: FC<SidebarMenuProps> = (props) => {
  const { collapse, setCollapse } = props

  const { getAccess, menu } = useRole()

  // const MENU_ITEMS: MenuLinkProps[] = [
  //   {
  //     title: 'Главная',
  //     url: '/',
  //     icon: <Icon section="general" size="20" name="main" />,
  //     access: getAccess('MAIN', ['READ']),
  //   },
  //   {
  //     title: 'ЭПЛ',
  //     icon: <Icon section="general" size="20" name="road-list" />,
  //     access: getAccess('WAYBILL', ['READ']),
  //     subLinks: [
  //       {
  //         title: 'Путевые листы',
  //         url: '/waybill',
  //       },
  //       {
  //         title: 'Справочники',
  //         url: '/dictionaries',
  //       },
  //       {
  //         title: 'Заявки',
  //         //url: '/applications',
  //       },
  //       {
  //         title: 'Инциденты',
  //         //url: '/incidents',
  //       },
  //       // {
  //       //   title: 'Отчёты',
  //       //   url: '/analysis',
  //       // },
  //     ],
  //   },
  //   {
  //     title: 'Медосмотры',
  //     icon: <Icon section="general" size="20" name="med-watch" />,
  //     //access: getAccess('CLIENTS', []),
  //     access: getAccess('MEDEXAM', ['READ']),
  //     url: '/reports/medreports/1',
  //   },
  //   {
  //     title: 'Медорганизация',
  //     icon: <Icon section="general" size="20" name="med-exam" />,
  //     access: getAccess('MEDORGANIZATION', ['READ']),
  //     subLinks: [
  //       {
  //         title: 'Медосмотры',
  //         //url: '/med-exams',
  //       },
  //       {
  //         title: 'График смен',
  //         //url: '/schedule',
  //       },
  //       // {
  //       //   title: 'Мои Документы',
  //       //   //url: '/documents',
  //       // },
  //       // {
  //       //   title: 'Отчёты',
  //       //   url: '/reports/medreports/1',
  //       // },
  //       // {
  //       //   title: 'Медкомплексы',
  //       //   url: '/medcomplex_watch',
  //       // },
  //     ],
  //   },
  //   {
  //     title: 'Клиенты',
  //     icon: <Icon section="general" size="20" name="client" />,
  //     access: getAccess('CLIENTS', ['READ']),
  //   },
  //   {
  //     title: 'Техосмотры',
  //     icon: <Icon section="general" size="20" name="tech-inspect" />,
  //     //url: '/tech-inspect',
  //     access: getAccess('TECHINSPECT', ['READ']),
  //   },
  //   {
  //     title: 'Администрация',
  //     icon: <Icon section="general" size="20" name="control" />,
  //     //url: '/tech-inspect',
  //     access: getAccess('MEDCOMPLEX', ['READ', 'UPDATE']),
  //     subLinks: [
  //       {
  //         title: 'Медкомплексы',
  //         url: '/medcomplex',
  //       },
  //     ],
  //   },
  //   {
  //     /* Divider */
  //   },
  //   {
  //     title: 'Аналитика',
  //     icon: <Icon section="general" size="20" name="analysis" />,
  //     //url: '/analisys-main',
  //     access: getAccess('ANALYTICS', ['READ']),
  //     subLinks: [
  //       {
  //         title: 'Топливо',
  //         // url: '/fuel',
  //         access: getAccess('ANALYTICS_FUEL', ['READ']),
  //       },
  //       {
  //         title: 'Пробег',
  //         url: '/analysis',
  //         access: getAccess('ANALYTICS_MILEAGE', ['READ']),
  //       },
  //       {
  //         title: 'Итоги медосмотров',
  //         // url: '/med_exam_results',
  //         access: getAccess('ANALYTICS_MEDEXAMRESULTS', ['READ']),
  //       },
  //       {
  //         title: 'Нагрузка медка',
  //         // url: '/med_exam_results',
  //         access: getAccess('ANALYTICS_MEDICLOAD', ['READ']),
  //       },
  //       {
  //         title: 'Работа медиков',
  //         // url: '/med_exam_results',
  //         access: getAccess('ANALYTICS_MEDICWORK', ['READ']),
  //       },
  //     ],
  //   },
  //   {
  //     title: 'Мои Организации',
  //     icon: <Icon section="general" size="20" name="organization" />,
  //     url: '/organization',
  //     access: getAccess('ORGANIZATION', ['READ']),
  //   },
  //   {
  //     title: 'Помощь',
  //     icon: <Icon section="general" size="20" name="help" />,
  //     url: '/help',
  //     access: getAccess('HELP', ['READ']),
  //   },
  //   {
  //     title: 'Осмотры',
  //     icon: <Icon section="general" size="20" name="inspections" />,
  //     access: getAccess('INSPECTIONS', ['READ']),
  //   },
  //   {
  //     title: 'Отчёты',
  //     icon: <Icon section="general" size="20" name="reports" />,
  //     access: getAccess('REPORTS', ['READ']),
  //   },
  //   {
  //     title: 'График смен',
  //     icon: <Icon section="general" size="20" name="shiftschedule" />,
  //     access: getAccess('SHIFTSCHEDULE', ['READ']),
  //   },
  //   {
  //     title: 'Мои Документы',
  //     icon: <Icon section="general" size="20" name="mydocuments" />,
  //     access: getAccess('MYDOCUMENTS', ['READ']),
  //   },
  // ]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderItems = menu?.map((item: any, index: number) => (
    <MenuLink
      url={item?.url?.pathname}
      title={item?.title}
      icon={item?.icon}
      subLinks={item?.subLinks}
      collapse={collapse}
      setCollapse={setCollapse}
      access={item?.url?.access}
      key={index}
    />
  ))

  return <Box sx={styles.root}>{renderItems}</Box>
}
